<template>
    <div class="row">
        <div class="col-12">
            <div class="table-responsive mb-0">
                <table class="table table-bordered table-sm mb-0">
                    <thead>
                        <tr>
                            <th class="text-nowrap">Durum</th>
                            <th class="text-nowrap text-right">Tahsil Edilen Tutar (TL)</th>
                            <th class="text-nowrap text-right">Kalan Tutar (TL)</th>
                            <th class="text-nowrap text-right">Toplam Tutar (TL)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <b-badge :variant="statusVariant">
                                    {{ statusText }}
                                </b-badge>
                            </td>
                            <td class="text-right">{{ value.EmployeeDepositPaidAmount }}</td>
                            <td class="text-right">{{ value.EmployeeDepositAmount - value.EmployeeDepositPaidAmount }}</td>
                            <td class="text-right">{{ value.EmployeeDepositAmount }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import { BBadge } from "bootstrap-vue";

export default {
    components: {
        BBadge,
    },
    props: {
        value: Object,
    },
    computed: {
        isCollected() {
            if (!this.value || this.value.EmployeeDepositAmount === 0) return false;
            return this.value.EmployeeDepositPaidAmount >= this.value.EmployeeDepositAmount;
        },
        statusText() {
            return this.isCollected ? "Tahsil Edildi" : "Tahsil Edilmedi";
        },
        statusVariant() {
            return this.isCollected ? "success" : "warning";
        },
    },
};
</script>

<style></style>
